import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Gatekeeper_v2';
import './index.css'; // Assuming you have a basic CSS file for Tailwind styles

// ====================================================================
// CRITICAL: Injecting Firebase Configuration as Global Variables
// The Gatekeeper component expects these variables for initialization.
//
// NOTE: In a professional deployment, you would load these variables 
// from environment files (.env) rather than hardcoding them.
// ====================================================================

// Firebase Configuration JSON you provided:
const firebaseConfig = {
  apiKey: "AIzaSyCURf-oOizhv1qOLKgtjCuizOk5UoUXsXI",
  authDomain: "genesisgatekeeper.firebaseapp.com",
  projectId: "genesisgatekeeper",
  storageBucket: "genesisgatekeeper.firebasestorage.app",
  messagingSenderId: "985688670590",
  appId: "1:985688670590:web:c1e69cf209036544b7332f",
  measurementId: "G-2WRL5E61XH"
};

// 1. Set the global Firebase config variable (stringified JSON)
// This matches the format expected by the Gatekeeper component.
window.__firebase_config = JSON.stringify(firebaseConfig);

// 2. Set the global App ID (using the projectId, which serves as a unique identifier)
// This matches the format expected by the Gatekeeper component's path construction.
window.__app_id = firebaseConfig.projectId;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);